// Built In Templates
export const templateNamesToIconsMap: Record<string, string> = {
  Agentkit: '/imgs/agentKit.svg',
  'agentkit-ts': '/imgs/agentKit.svg',
  hyperbolic: '/imgs/agentKit.svg',
  'Base Agent': '/imgs/basedAgent.svg',
  Eliza: '/imgs/eliza.svg',
  ElizaBNB: '/imgs/eliza.svg',
};
